import { jourTravaille } from './semaine';

/**
 * Les lignes du relevé mensuel, jour par jour : chaque jour ouvrable (du lundi
 * au vendredi en Suisse, selon le week-end du pays ailleurs), du 1er au
 * dernier jour du mois, même sans heures (« — »), et les jours de repos
 * seulement quand des heures y sont notées.
 *
 * <p>Le relevé imprimé ne montrait que les jours pointés : un jour manquant ne
 * se voyait pas, et le patron devait recompter le mois sur un calendrier.
 *
 * @param {string} ym mois au format « 2026-10 »
 * @param {Array<{k: string}>} lignes lignes pointées du mois, k = « 20261005 »
 * @param {string|null} [pays] code du pays ; ses jours de repos (lib/semaine.js)
 * @returns {Array<object>} les lignes du mois, dans l'ordre des jours ; un jour
 *   sans heures porte `vide: true`
 */
export function joursDuMois(ym, lignes, pays) {
  const [annee, mois] = String(ym || '')
    .split('-')
    .map(Number);
  if (!annee || !mois) return [...(lignes || [])];
  const parJour = new Map();
  (lignes || []).forEach((l) => {
    const liste = parJour.get(l.k) || [];
    liste.push(l);
    parJour.set(l.k, liste);
  });
  const dernier = new Date(annee, mois, 0).getDate();
  const sortie = [];
  for (let j = 1; j <= dernier; j += 1) {
    const jour = new Date(annee, mois - 1, j);
    const semaine = jour.getDay();
    const k = String(annee) + String(mois).padStart(2, '0') + String(j).padStart(2, '0');
    const notees = parJour.get(k);
    if (notees) {
      const repos = !jourTravaille(semaine, pays);
      notees.forEach((l) => sortie.push({ ...l, jourSemaine: semaine, repos }));
      parJour.delete(k);
    } else if (jourTravaille(semaine, pays)) {
      sortie.push({
        k,
        date: String(j).padStart(2, '0') + '.' + String(mois).padStart(2, '0') + '.' + annee,
        chantier: '—',
        h: 0,
        e: '',
        s: '',
        note: '',
        vide: true,
        jourSemaine: semaine,
      });
    }
  }
  // Une ligne d'une date illisible ne se perd pas : elle suit, à la fin.
  parJour.forEach((liste) => sortie.push(...liste));
  return sortie;
}
